import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {CommodityModel, CommodityTypeId} from '@shared/models/commodity.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {Observable} from 'rxjs';
import {SelectCenterComponent} from '@shared/components/select-center/select-center.component';
import { PermissionService } from './permission.service';
import { Module, ModuleService } from './module.service';
import { CommoditiesUtilityService } from './commodities-utility.service';
import { isArray } from 'util';
import { UserPermissionsModel } from '../models/user-permission.model';

@Injectable()
export class SelectCommoditiesService {
	environment: AppConfigEnvironment;
	protected commoditiesSubject: Subject<CommodityModel[]> = new Subject<CommodityModel[]>();
	commoditiesObservable: Observable<CommodityModel[]> = this.commoditiesSubject.asObservable();
	private allCommodities: CommodityModel[];
	private commoditiesClustered: CommodityModel[];
	private currentCommodities: CommodityModel[];
	private selectCenterComponent: SelectCenterComponent;
	private isAC: boolean;
	private userPermission: UserPermissionsModel

	private get brotherCommodities(): CommodityModel[] {
		let commoditiesByParent: CommodityModel[];
		if (this.allCommodities && this.allCommodities.length && this.currentCommodities && this.currentCommodities.length) {
			commoditiesByParent = this.allCommodities.filter(c => this.currentCommodities.some(co => co.ald_parent_id === c.ald_parent_id));
		} else {
			commoditiesByParent = this.currentCommodities || [];
		}
		return commoditiesByParent;
	}

	get hasTireOperator(): boolean {
		return this.brotherCommodities.some(c => c.type_id === CommodityTypeId.TIER);
	}

	get hasCarbodyOperator(): boolean {
		return this.brotherCommodities.some(c => c.type_id === CommodityTypeId.CARBODY);
	}

	get hasMechanicOperator(): boolean {
		return this.brotherCommodities.some(c => c.type_id === CommodityTypeId.MECHANIC);
	}

	constructor(
		private appConfig: AppConfigEnvironmentService,
		private permissionService: PermissionService,
		private moduleService: ModuleService,
		private commoditiesUtilityService: CommoditiesUtilityService,
	) {
		this.environment = appConfig.Environment;
		this.isAC = this.permissionService.getCurrentUserPermissions().isAssistanceCenterOperator();
		this.userPermission = this.permissionService.getCurrentUserPermissions();
	}

	getCurrentCommodities(): CommodityModel[] { 
		return this.currentCommodities;
	}

	getCurrentCommoditiesByCenterId(): CommodityModel[] {

		const centerId = this.currentCommodities[0].center_id;
		return this.allCommodities.filter((x: CommodityModel) => x.center_id === centerId);
	}

	getCurrentCommoditiesByCommoditiesCenterId(commodity:CommodityModel): CommodityModel[] {
		const centerId = commodity.center_id;
		return this.allCommodities.filter((x: CommodityModel) => x.center_id === centerId);
	}

	// metodo inutile
	getIDCommodities(): string[] {
		/**  chiamata per closing return array di id nemo  **/
		return Utilities.isVoid(this.currentCommodities) ? [] : this.currentCommodities
			.filter(commodity => commodity.ald_commodity_id !== CommodityModel.allCentersID)
			.map(commodity => commodity.id);
	}

	getIDCommoditiesFiltered(): CommodityModel[] {
		return Utilities.isVoid(this.currentCommodities) ? [] : this.currentCommodities
			.filter(commodity => commodity.ald_commodity_id !== CommodityModel.allCentersID)
			.map(commodity => commodity);
	}

	getAldCommodityIds(): number[] {
		if (Utilities.APPCONFIGENVIRONMENT.environment === 'aaa') {
			return Utilities.isVoid(this.currentCommodities) ? [] : this.currentCommodities
				.filter(commodity => commodity.ald_commodity_id !== CommodityModel.allCentersID)
				.map(commodity => commodity.ald_commodity_id);
		} else {
			return Utilities.isVoid(this.currentCommodities) ? [] : this.currentCommodities
				.filter(commodity => commodity.ald_commodity_id !== CommodityModel.allCentersID)
				.map(commodity => commodity.ald_supplier_id);
		}
		/**  chiamata per delivery return array di ald_supplier_id **/
	}

	getAldSupplierIds(): number[] {
		/**  chiamata per closing return array di ald_supplier_id **/
		return Utilities.isVoid(this.currentCommodities) ? [] : this.currentCommodities
			.filter(commodity => commodity.ald_commodity_id !== CommodityModel.allCentersID)
			.map(commodity => commodity.ald_supplier_id);
	}

	getAldCommoditiesIds(): number[] {
		/**  chiamata per closing return array di ald_supplier_id **/
		return Utilities.isVoid(this.currentCommodities) ? [] : this.currentCommodities
			.filter(commodity => commodity.ald_commodity_id !== CommodityModel.allCentersID)
			.map(commodity => commodity.ald_commodity_id);
	}

	getTyreCommodities(): string[] {
		return Utilities.isVoid(this.currentCommodities) ? [] : this.currentCommodities
			.filter(commodity => commodity.ald_commodity_id !== CommodityModel.allCentersID)
			.map(commodity => commodity.id);
	}
	//submitGetlist serve ad effettuare la next dell'observable in questo modo possiamo evitare di effettuare getList nel costruttore
	setCommodities(commodities: CommodityModel | CommodityModel[], submitGetlist: boolean): void {

		try {
			
			let res: CommodityModel[];
	
			if (!isArray(commodities)) {
				
				res = ((): CommodityModel[] => {
					
					const comm: CommodityModel = commodities as CommodityModel;
			
					if (this.commoditiesUtilityService.multiCommodities) {
						return this.getCurrentCommoditiesByCommoditiesCenterId(comm);
					}

					return [comm];
				})();
			
			} else {
				res = commodities as CommodityModel[];
			}
	
			this.currentCommodities = res;
			this.userPermission.setCommodities(res);
			
			if(submitGetlist){
				this.commoditiesSubject.next(res);
			}
			

		} catch (e) {
			console.error(e);
		}

	}

	getIdByAldCommodityId(commodity_id: string): string {
		return this.currentCommodities.filter(commodity => commodity.ald_commodity_id === +commodity_id).map(commodity => commodity.id)[0];
	}

	setAll(commodities: CommodityModel[]): void {

		this.allCommodities = commodities;
		this.commoditiesClustered = this.clusteringCommodities(commodities);
	}

	getAll(): CommodityModel[] {
		return this.allCommodities || [];
	}

	getAllClustered(): CommodityModel[] {
		return this.commoditiesClustered || [];
	}

	getAllIDs(): string[] {
		return this.getAll().filter(commodity => commodity.ald_commodity_id !== CommodityModel.allCentersID).map(commodity => commodity.id);
	}
		
	/**
	 * Raggruppa le commodities associate ad un centro (quindi filtra i duplicati), 
	 * solitamente serve per i profili NON CENTRO, 
	 * che vedono i vari centri come unica entità
	 * 
	 * @param {CommodityModel[]} commodities
	 * @returns {CommodityModel[]}
	 */
	clusteringCommodities(commodities: CommodityModel[]): CommodityModel[] {

		if (Utilities.isEmpty(commodities)) {
			return [];
		}

		// L'utenza centro deve vedere i moduli "splittati" solo per SHORT-TERM
		if (this.hasSplittedCommodities()) {
			return commodities;
		}

		// Raggruppa le commodities per centro, quindi filtra i duplicati
		let cluster: CommodityModel[] = [];
		commodities.forEach(x => cluster = (!cluster.some(y => y.center_id === x.center_id)) ? [...cluster, x] : cluster);
		return cluster;
	}

	isCommodityAvailable(c: CommodityModel): boolean {
		
		// Check all commodities with the same center_id of input commodity
		
		return (
			this.allCommodities && 
			!!this.allCommodities.find((x: CommodityModel) => {
				return (
					x.center_id === c.center_id &&
					// x.id === c.id && 
					x.status === 1
				)
			})
		);
	}

	isCurrentCommoditiesAvailable(): boolean {

		// Commodity already selected
		if (this.currentCommodities.length === 1)
			return this.isCommodityAvailable(this.currentCommodities[0]);

		// No commodity already selected
		return true;
	}

	hasSplittedCommodities(): boolean {
		const modules: Module[] = [Module.FLOTTA_POOL, Module.BOOKINGS];
		return modules.includes(this.moduleService.getCurrentModule()) && this.isAC;
	}
}
